import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {AbstractControl} from '@angular/forms';
import {TranslateService} from '@ngx-translate/core';
import {Subscription} from 'rxjs';

@Component({
  selector: 'wsd-extended-input',
  templateUrl: './extended-input.component.html',
  styleUrls: ['./extended-input.component.css']
})
export class ExtendedInputComponent implements OnInit, OnDestroy {

  @Input()
  control: AbstractControl;

  @Input()
  label: string;

  @Input()
  errorMessages: any;

  private errorMessagesCopy: any;

  private translateSubscription: Subscription;

  constructor(private translate: TranslateService) {
  }

  ngOnInit() {
    this.init();
    this.translateSubscription = this.translate.onDefaultLangChange.subscribe(
      (lang: any) => this.init()
    );
  }

  ngOnDestroy() {
    this.translateSubscription.unsubscribe();
  }

  private init() {
    if (this.errorMessages) {
      this.errorMessagesCopy = this.errorMessages;
      return;
    }
    // just provide required error message as default if no error message is provided at all
    if (this.translate.getDefaultLang()) {
      this.errorMessagesCopy = {
        'required': {label: 'VALIDATION_ERRORS.REQUIRED'},
        'maxlength': {label: 'VALIDATION_ERRORS.MAX_LENGTH'},
        'email': {label: 'VALIDATION_ERRORS.EMAIL'},
        'min': {label: 'VALIDATION_ERRORS.MIN'},
        'max': {label: 'VALIDATION_ERRORS.MAX'}
      };
    }
  }

  get errorMessage() {
    for (const propertyName in this.control.errors) {
      if (this.control.errors.hasOwnProperty(propertyName) && (this.control.dirty)) {
        return this.findErrorMessage(propertyName, this.control.errors[propertyName]);
      }
    }
    return null;
  }

  private findErrorMessage(error: any, values: any): string {
    if (this.errorMessagesCopy && this.errorMessagesCopy[error]) {
      const errorMessage = this.errorMessagesCopy[error];

      if (typeof errorMessage === 'object') {
        return this.translate.instant(errorMessage.label, values);
      }

      return errorMessage;
    }

    return 'Undefined error';
  }

}
